export const educationData = [
  {
    id: 1,
    institution: 'Bundelkhand Institute of Engineering and Technology, Jhansi',
    course: 'Bachelor Of Technology',
    startYear: '2019',
    endYear: '2023',
  },
  // {
  //   id: 2,
  //   institution: 'Pt. Ram Ji Lal Inter College, Kanpur Dehat',
  //   course: 'Higher Secondary',
  //   startYear: '2018',
  //   endYear: '2020',
  // },
  // {
  //   id: 3,
  //   institution: 'Pt. Ram Ji Lal Inter College, Kanpur Dehat',
  //   course: 'Secondary School',
  //   startYear: '2008',
  //   endYear: '2018',
  // },
];
